import React from "react";
import "../footer.css";

// Screen-reader text for links that open in a new tab.
const NewTab = () => <span className="sr-only"> (opens in a new tab)</span>;

const ExternalIcon = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
    strokeLinecap="round" aria-hidden="true" focusable="false">
    <path d="M7 17L17 7" />
    <path d="M8 7h9v9" />
  </svg>
);

// Footer (foundation, Footer.dc.html). Also rendered on the static blog pages (src/index.js).
const Footer = () => {
  return (
    <footer className="footer fn-ft">
      <div className="fn-ft-in">
        <div className="fn-ft-grid">
          <div className="fn-ft-brand">
            <span className="fn-ft-name">BossInvestor</span>
            <span className="fn-ft-company">BossInvestor Analytics Solutions Pvt. Ltd.</span>
            <span className="fn-ft-reg">SEBI Registered Research Analyst</span>
            <span className="fn-ft-reg fn-num">Registration No. INH000024143</span>
            <span className="fn-ft-reg fn-num">CIN U62099PN2025PTC237674</span>
            <div className="fn-ft-socials">
            <a
              className="fn-ft-social"
              href="https://x.com/bossinvestor24"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="BossInvestor on X (opens in a new tab)"
            >
              <svg aria-hidden="true" focusable="false" width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.746l7.73-8.835L1.254 2.25H8.08l4.253 5.622zm-1.161 17.52h1.833L7.084 4.126H5.117z"></path>
              </svg>
            </a>
            <a
              className="fn-ft-social"
              href="https://www.linkedin.com/company/bossinvestor2024/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="BossInvestor on LinkedIn (opens in a new tab)"
            >
              <svg aria-hidden="true" focusable="false" width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"></path>
              </svg>
            </a>
            <a
              className="fn-ft-social"
              href="https://youtube.com/@bossinvestor"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="BossInvestor on YouTube (opens in a new tab)"
            >
              <svg aria-hidden="true" focusable="false" width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                <path d="M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"></path>
              </svg>
            </a>
            <a
              className="fn-ft-social"
              href="https://t.me/bossinvestor24"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="BossInvestor on Telegram (opens in a new tab)"
            >
              <svg aria-hidden="true" focusable="false" width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.96 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.244-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"></path>
              </svg>
            </a>
            </div>
          </div>

          <nav className="fn-ft-col" aria-labelledby="fn-ft-support">
            <span className="fn-ft-hd" id="fn-ft-support">Support</span>
            <a className="fn-ft-link" href="/contact">Contact us</a>
            <a className="fn-ft-link" href="/accessibility">Accessibility</a>
            <a className="fn-ft-link" href="https://scores.sebi.gov.in/" target="_blank" rel="noopener noreferrer">
              Compliance redressal
              <ExternalIcon />
              <NewTab />
            </a>
            <a className="fn-ft-link" href="/escalation_matrix">Escalation matrix</a>
            <a className="fn-ft-link" href="/grievance_redressal">Grievance redressal</a>
            <a className="fn-ft-link" href="/statutory_details">Statutory details</a>
            <a className="fn-ft-link" href="https://smartodr.in/" target="_blank" rel="noopener noreferrer">
              Smart ODR
              <ExternalIcon />
              <NewTab />
            </a>
            <a className="fn-ft-link" href="/shipping">Shipping</a>
          </nav>

          <nav className="fn-ft-col" aria-labelledby="fn-ft-legal">
            <span className="fn-ft-hd" id="fn-ft-legal">Legal</span>
            <a className="fn-ft-link" href="/terms-and-conditions">Terms and conditions</a>
            <a className="fn-ft-link" href="/privacy-policy">Privacy policy</a>
            <a className="fn-ft-link" href="/cancellationrefunds">Cancellation and refunds</a>
            <a className="fn-ft-link" href="/investor_charter">Investor charter</a>
            <a className="fn-ft-link" href="/investor_monthly_complaints">Investor monthly complaints</a>
            <a className="fn-ft-link" href="/about">About us</a>
          </nav>

          <div className="fn-ft-col fn-ft-apps">
            <span className="fn-ft-hd">Get the app</span>
            <a
              className="fn-ft-app"
              href="https://apps.apple.com/us/app/bossinvestor/id6748985020"
              target="_blank"
              rel="noopener noreferrer"
            >
              <svg className="fn-ft-app-icon" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false">
                <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09zM12.43 7.07c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z" />
              </svg>
              App Store
              <NewTab />
            </a>
            <a
              className="fn-ft-app"
              href="https://play.google.com/store/apps/details?id=com.bossinvestor.app"
              target="_blank"
              rel="noopener noreferrer"
            >
              <svg className="fn-ft-app-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                <path
                fill="#34A853"
                d="M3.6 1.8 13.8 12 3.6 22.2c-.4-.2-.6-.6-.6-1V2.8c0-.4.2-.8.6-1z"
              />
              <path
                fill="#FBBC04"
                d="M17 8.7 13.8 12 17 15.3l4-2.3c.8-.5.8-1.5 0-2L17 8.7z"
              />
              <path
                fill="#EA4335"
                d="M3.6 22.2 13.8 12 17 15.3 4.7 22.4c-.4.2-.8.1-1.1-.2z"
              />
              <path
                fill="#4285F4"
                d="M3.6 1.8c.3-.2.7-.3 1.1-.1L17 8.7 13.8 12 3.6 1.8z"
              />
              </svg>
              Google Play
              <NewTab />
            </a>
          </div>
        </div>

        <div className="fn-ft-bottom">
          <p>
            Not investment advice {"·"} Dynamic Allocator signal is a model output, not a personalised
            recommendation {"·"} Past performance does not guarantee future results
          </p>
          <p className="fn-num">
            {"©"} {new Date().getFullYear()} BossInvestor Analytics Solutions Pvt. Ltd. {"·"} SEBI
            INH000024143
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;